import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';

const CybersecurityProcessTechnicalArticlePage = () => (
  <DataDrivenArticlePage slug="article-cybersecurity-process" pdfSlug="cybersecurity-process" />
);

export default CybersecurityProcessTechnicalArticlePage;
